
import clsx from 'clsx';

export interface PageHeaderProps {
  title: string;
  description?: string;
  leading?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Provides a consistent heading block for dashboard pages including optional description and actions.
 */
export function PageHeader({
  title,
  description,
  leading,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={clsx(
        'flex flex-col gap-4 border-b border-gray-100 pb-5 sm:flex-row sm:items-center sm:justify-between dark:border-gray-800',
        className,
      )}
    >
      <div className="flex flex-1 items-start gap-3">
        {leading && (
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-yellow-100 via-yellow-200 to-yellow-300 text-yellow-800 shadow-sm dark:from-yellow-900 dark:via-yellow-800 dark:to-yellow-700 dark:text-yellow-200">
            {leading}
          </div>
        )}
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">
            {title}
          </h1>
          {description && (
            <p className="text-sm text-gray-600 dark:text-gray-400">{description}</p>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex shrink-0 flex-wrap items-center gap-2 text-sm sm:justify-end">
          {actions}
        </div>
      )}
    </div>
  );
}
